import { handleActions } from 'redux-actions';
import {
  setProgramList,
  fetchProgramList,
  setProgramError,
  setProgramFilters,
  setProgramOptionsList,
  toggleCheckedPrograms,
  uncheckAllPrograms,
  setProgramCount,
} from './actions';

const defaultState = {
  loading: false,
  checkedProgramIds: [],
  filters: {
    pageNumber: 1,
    pageSize: 10,
    sortBy: '',
    search: '',
    isSortOrderDescending: false,
    status: null,
  },
  totalRecords: 0,
  data: [],
  options: [],
  programCount: 0,
  error: null,
};

export default handleActions(
  {
    [fetchProgramList](state) {
      return {
        ...state,
        loading: true,
        data: [],
      };
    },
    [setProgramList](state, { payload }) {
      return {
        ...state,
        loading: false,
        data: payload.data.records,
        totalRecords: payload.data.totalRecords,
        error: null,
      };
    },
    [setProgramOptionsList](state, { payload }) {
      return {
        ...state,
        options: payload.data,
      };
    },
    [setProgramError](state, { payload }) {
      return {
        ...state,
        data: [],
        loading: false,
        totalPages: defaultState.totalPages,
        error: payload?.message,
      };
    },
    [setProgramFilters](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
        checkedProgramIds: [],
      };
    },
    [toggleCheckedPrograms](state, { payload: programId }) {
      const checkedIds = state.checkedProgramIds;
      return {
        ...state,
        checkedProgramIds: checkedIds.includes(programId)
          ? checkedIds.filter((id) => id !== programId)
          : [...checkedIds, programId],
      };
    },
    [uncheckAllPrograms](state) {
      return {
        ...state,
        checkedProgramIds: [],
      };
    },
    [setProgramCount](state, { payload }) {
      return {
        ...state,
        loading: false,
        programCount: payload,
        error: null,
      };
    },
  },
  defaultState,
);
